var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73296 20.829C7.2261 21.0936 6.61292 21.047 6.15184 20.7089C5.69076 20.3708 5.462 19.8 5.56196 19.237L6.37097 14.6L2.96496 11.336C2.54864 10.939 2.39606 10.3388 2.57222 9.79117C2.74838 9.24352 3.22225 8.84486 3.79197 8.76501L8.52097 8.08901L10.656 3.83001C10.9091 3.31923 11.4299 2.99609 12 2.99609C12.57 2.99609 13.0908 3.31923 13.344 3.83001L15.479 8.08901L20.208 8.76501C20.7777 8.84486 21.2515 9.24352 21.4277 9.79117C21.6039 10.3388 21.4513 10.939 21.035 11.336L17.629 14.6L18.438 19.238C18.5379 19.801 18.3092 20.3718 17.8481 20.7099C17.387 21.048 16.7738 21.0946 16.267 20.83L12 18.625L7.73296 20.829Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6b057a57dfac5d552a531fae0fabdd89.svg";
export { ForwardRef as ReactComponent };